import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/layout';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import PropertyDetails from './pages/PropertyDetails';
import MhadaProperties from './pages/MhadaProperties';
import SecurityServices from './pages/Security';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mhada-properties" element={<MhadaProperties />} />
          <Route path="/property/:id" element={<PropertyDetails />} />
          <Route path="/security" element={<SecurityServices />} />
        </Route>
      </Routes>
    </Router>
  );
}